import { Meta } from '@storybook/addon-docs/blocks';
import Contributing from '../../contributing.mdx';

<Meta title="Overview/Contributing" />

<Contributing />
